import { useState } from 'react';
import { ExpandedContext } from './expanded-context';
import { ExpandedContextProviderProps } from './expanded-context-provider.types';

export const ExpandedContextProvider = ({ children }: ExpandedContextProviderProps) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<ExpandedContext.Provider
			value={{
				isOpen,
				setIsOpen,
			}}
		>
			{children}
		</ExpandedContext.Provider>
	);
};
